//不得引入const
var Utils = {
    isEmpty(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    },
    isAndroid() {
        return /android/.test(navigator.userAgent.toLowerCase());
    },
    isIphone() {
        return /iphone/.test(navigator.userAgent.toLowerCase());
    },
    isAndroidApp() {
        var u = navigator.userAgent, app = navigator.appVersion;
        return /android.*mobile\s\S*$/i.test(u)
    },
    isIphoneApp() {
        var u = navigator.userAgent, app = navigator.appVersion;
        return /iphone.*mobile\/\S*$/i.test(u)
    },
    clientType() {
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
            return 'phone'
        } else {
            return 'pc'
        }
    },
    /**
     * get pay way
     * @return  String  SCAN|ANDROID|IOS|H5  default: H5
     */
    getPayWay : function ()
    {
        var type = this.clientType();
        var androidApp = this.isAndroidApp();
        var iphoneApp = this.isIphoneApp();
        var payWay;

        if(type === 'pc'){
            payWay = 'SCAN';
            return payWay;
        }

        if(androidApp){
            payWay = 'ANDROID';
            return payWay;
        }
        else if (iphoneApp) {
            payWay = 'IOS';
            return payWay;
        }

        payWay = 'H5'
        return payWay
    },
    //isAndroid(){
    //    return /android/.test(navigator.appVersion.toLowerCase());
    //},
    //isIphone(){
    //    return /iphone/.test(navigator.appVersion.toLowerCase());
    //},
    transform(className, realWidth = 375) {
        debugger;
        var node = null;
        if (!className) {
            node = document.body; // style add to <body> as default
        } else {
            node = document.getElementsByClassName(className)[0]; // specific class
        }

        function bigger() {
            if (window.innerWidth !== realWidth || window.orientation === 0 || window.orientation === 180) {
                // main function
                let scale = (window.innerWidth / realWidth);
                Utils.log(window.innerHeight);
                if (window.innerHeight >= node.scrollHeight) {
                    node.style.height = window.innerHeight * scale + "px";
                }
                node.style.width = realWidth + "px";
                node.style.webkitTransform = "scale(" + scale + ")";
                node.style.webkitTransformOrigin = "0 0";
                node.style.transform = "scale(" + scale + ")";
                node.style.transformOrigin = "0 0";
            }
        }

        function run() {
            bigger();
            // fix screen rotate animation time
            setTimeout(function () {
                bigger();
            }, 200);
        }


        run();
        window.removeEventListener(window.hasOwnProperty('onorientationchange') ? "orientationchange" : "resize", run, false);
        window.addEventListener(window.hasOwnProperty('onorientationchange') ? "orientationchange" : "resize", run, false);
    },
    /**
     *
     * @param getData function return {img_url,link,desc,title}
     * @param callback
     */
    setPageTitle(title) {
        //alert("setTitle:" + title);
        try {
            document.title = title;
            window.wx && wx.invoke('setPageTitle', {
                "title": title
            }, function (res) {
                //alert(res.err_msg);
            });
        } catch (e) {

        }
    },
    wxShare2(getData, callback) {
        let bind = function () {
            // 分享到朋友圈;
            WeixinJSBridge.on('menu:share:timeline', function () {
                WeixinJSBridge.invoke('shareTimeline', getData(1), callback);
            });

            // 发送给好友;
            WeixinJSBridge.on('menu:share:appmessage', function () {
                WeixinJSBridge.invoke('sendAppMessage', getData(2), callback);
            });

            // 分享到微博;
            WeixinJSBridge.on('menu:share:weibo', function () {
                var data = getData();
                data = {
                    url: data.link,
                    content: '【' + data.title + '】' + ' ' + data.desc + ' ' + data.link,
                    img_url: data.img_url
                };
                WeixinJSBridge.invoke('shareWeibo', data, callback);
            });
            // 分享到Facebook
            WeixinJSBridge.on('menu:share:facebook', getData(), callback);

            //分享到QQ
            WeixinJSBridge.on("menuItem:share:qq", function () {
                WeixinJSBridge.invoke('shareQQ', getData(), callback);
            });
        };

        if (window.WeixinJSBridge)
            bind();
        else
            document.addEventListener('WeixinJSBridgeReady', bind, false);
    },
    wxShare(img, title, desc, url, callback) {
        function getWxShareData() {
            if (!url) {
                if (window.location.href.indexOf('.qq.com') == -1) {
                    url = window.location.href;
                } else {
                    var objUrl = Utils.param();
                    url = 'http://yao.qq.com/tv/entry?redirect_uri={#r#}&cb41faa22e731e9b={#cb41faa22e731e9b#}';
                    url = url.replace('{#r#}', encodeURIComponent(window.location.href)).replace('{#cb41faa22e731e9b#}', objUrl['cb41faa22e731e9b']);
                }
            }

            if (!img) {
                var imgs = document.getElementsByTagName('IMG');
                if (imgs.length) {
                    img = encodeURIComponent(imgs[0].src);
                }
            }
            return {
                'img_url': img,
                'link': url,
                'desc': desc,
                'title': title
            };
        }

        Utils.wxShare2(getWxShareData, callback);
    },
    log(word) {
        try {
            let obj = Utils.param();
            if (obj.debug == 1) {
                alert(word);
            } else {
                console.log(word)
            }
        } catch (e) {

        }
    },
    getSmartInstance(ref) {
        return ref._reactInternalInstance._renderedComponent._renderedComponent._instance;
    },
    /**
     * target 如果为空则返回def
     */
    getDefault(target, def) {
        return target ? target : def
    },
    isArrayEmpty(array) {
        return !array || 0 == array.length;
    },
    each(obj, callback, _this) {
        let result = [];
        for (var i in obj) {
            if (callback) {
                result.push(callback.call(_this, i, obj[i]));
            }
        }
        return result;
    },
    isEqual(a, b) {
        //这里不严格相等  1 == "1"
        if (a === b) return true;
        var typeA = Object.prototype.toString.call(a);
        var typeB = Object.prototype.toString.call(b);
        if (typeA != typeB) return false;

        if ('[object Object]' == typeA) {
            for (var i in a) {
                if (!Utils.isEqual(a[i], b[i])) {
                    return false;
                }
            }
            for (var i in b) {
                if (!Utils.isEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        } else if ('[object Array]' == typeA) {
            if (a.length != b.length) return false;
            for (var i in a) {
                if (!Utils.isEqua(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        return false;
    },
    getCookie: function (name) {
        var reg = new RegExp("(^| )" + name + "(?:=([^;]*))?(;|$)"), val = document.cookie.match(reg);
        return val ? (val[2] ? unescape(val[2]) : "") : null;
    },
    setCookie: function (name, value, expires, path, domain, secure) {
        //写入COOKIES
        var exp = new Date(),
            expires = arguments[2] || null,
            path = arguments[3] || "/",
            domain = arguments[4] || null,
            secure = arguments[5] || false;

        expires ? exp.setMinutes(exp.getMinutes() + parseInt(expires)) : "";

        document.cookie = name + '=' + escape(value) + (expires ? ';expires=' + exp.toGMTString() : '') + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + (secure ? ';secure' : '');
    },
    strReplace: function (str, re, rt) {
        //同时支持json格式的批量替换和原始的全部替换
        if (rt != undefined) {
            replace(re, rt);
        } else {
            for (var key in re) {
                replace(key, re[key]);
            }
        }

        function replace(a, b) {
            try {
                var arr = str.split(a);
                str = arr.join(b);
            } catch (e) {
            }
        };
        return str;
    },
    classSet(...obj) {
        var cn = [];
        for (let k in obj) {
            if (typeof obj[k] == "string") {
                cn.push(obj[k]);
            } else if ('[object Object]' == Object.prototype.toString.call(obj[k])) {
                for (let i in obj[k]) {
                    if (obj[k][i]) {
                        cn.push(i);
                    }
                }
            }
        }
        return cn.join(" ")
    },
    /**
     *
     * @param str 20150101 2015-01-01 2015/01/01
     * @param split
     * @returns {Date}
     */
    str2Date: function (str, split) {
        str += "";
        var ar = [];
        if (split) {
            ar = str.split(split);
        } else {
            ar[0] = str.substr(0, 4);
            ar[1] = str.substr(4, 2);
            ar[2] = str.substr(6, 2);
        }
        // 返回日期格式
        return new Date(ar[0], ar[1] - 1, ar[2]);
    },
    makeUrl: function (data) {
        //将json串组装成为url键=值&键=值并返回
        var arr = [];
        for (var k in data) {
            if (typeof data[k] == "undefined") {
                continue;
            }
            arr.push(k + "=" + data[k]);
        }
        ;
        return arr.join("&");
    },
    /**
     *将数字分隔，默认,
     * @param num   201111
     * @returns {string|*}  "201,111
     */
    commafy: function (num, split) {
        if (!split) split = ",";
        num = num + "";
        var re = /(-?\d+)(\d{3})/
        while (re.test(num)) {
            num = num.replace(re, "$1" + split + "$2")
        }
        return num;
    },
    str2Json: function (str) {
        try {
            var json = (new Function("return " + str))();
            return json;
        } catch (e) {
            return {};
        }
    },
    encode4Json: function (str) {
        str = str.replace(/\\/gm, '\\\\');
        str = str.replace(/\r\n/gm, '\\n');
        str = str.replace(/[\r\n]/gm, '\\n');
        str = str.replace(/\s/gm, ' ');
        str = str.replace(/"/gm, '\\"');
        return str;
    },
    getOffsetDate: function (offSetInMill) {
        return new Date(Date.parse(new Date()) + offSetInMill);
    },
    formatDate: function (date, formatStr) {
        function $addZero(v, size) {
            for (var i = 0, len = size - (v + "").length; i < len; i++) {
                v = "0" + v;
            }
            ;
            return v + "";
        }

        //格式化时间
        var arrWeek = ['日', '一', '二', '三', '四', '五', '六'],
            str = formatStr
                .replace(/yyyy|YYYY/, date.getFullYear())
                .replace(/yy|YY/, $addZero(date.getFullYear() % 100, 2))
                .replace(/mm|MM/, $addZero(date.getMonth() + 1, 2))
                .replace(/m|M/g, date.getMonth() + 1)
                .replace(/dd|DD/, $addZero(date.getDate(), 2))
                .replace(/d|D/g, date.getDate())
                .replace(/hh|HH/, $addZero(date.getHours(), 2))
                .replace(/h|H/g, date.getHours())
                .replace(/ii|II/, $addZero(date.getMinutes(), 2))
                .replace(/i|I/g, date.getMinutes())
                .replace(/ss|SS/, $addZero(date.getSeconds(), 2))
                .replace(/s|S/g, date.getSeconds())
                .replace(/w/g, date.getDay())
                .replace(/W/g, arrWeek[date.getDay()]);
        return str;
    },
    query: function () {
        let query = location.hash.split("?")[1];
        if (!query) {
            return {}
        }
        return this.strToJson(query, "?", "&");
    },
    param: function () {
        return this.strToJson(location.search, "?", "&");
    },
    strToJson: function (str, filter, mark) {
        var arr = str.replace(filter, "").split(mark);
        var json = {};
        for (var i = 0, l = arr.length; i < l; i++) {
            var temp = arr[i].split("=");
            json[temp[0]] = temp[1];
        }
        return json;
    },
    parseUrl: function (url) {
        var a = document.createElement('a');
        a.href = url;
        return {
            source: url,
            protocol: a.protocol.replace(':', ''),
            host: a.hostname,
            port: a.port,
            query: a.search,
            params: (function () {
                var ret = {},
                    seg = a.search.replace(/^\?/, '').split('&'),
                    len = seg.length, i = 0, s;
                for (; i < len; i++) {
                    if (!seg[i]) {
                        continue;
                    }
                    s = seg[i].split('=');
                    ret[s[0]] = s[1];
                }
                return ret;
            })(),
            file: (a.pathname.match(/([^\/?#]+)$/i) || [, ''])[1],
            hash: a.hash.replace('#', ''),
            path: a.pathname.replace(/^([^\/])/, '/$1'),
            relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
            segments: a.pathname.replace(/^\//, '').split('/')
        };
    },
    transJson2str: function (o) {
        if (o === null) {
            return "null";
        }
        ;
        if (o == undefined) {
            return "";
        }
        var r = [];
        if (typeof o == "string")
            return "\"" + o.replace(/([\"\\])/g, "\\$1").replace(/(\n)/g, "\\n").replace(/(\r)/g, "\\r").replace(/(\t)/g, "\\t") + "\"";
        if (typeof o == "object") {
            if (o.nodeName) {
                r.push(["document node", "nodeName:" + o.nodeName, "id:" + o.id, "class:" + o.className].join('-'));
                r = "{" + r.join() + "}";
            } else if (!o.sort) {
                for (var i in o)
                    r.push("\"" + i + "\":" + Utils.transJson2str(o[i]));
                if (!!document.all && !/^\n?function\s*toString\(\)\s*\{\n?\s*\[native code\]\n?\s*\}\n?\s*$/.test(o.toString)) {
                    r.push("toString:" + o.toString.toString());
                }
                r = "{" + r.join() + "}";
            } else {
                for (var i = 0; i < o.length; i++)
                    r.push(Utils.transJson2str(o[i]));
                r = "[" + r.join() + "]";
            }
            return r;
        }
        return o.toString().replace(/\"\:/g, '":""');
    },
    getTarget: function (e, tag, parent) {
        var tar = e.srcElement || e.target;
        parent = parent || document.body;
        if (parent && tag && tar.nodeName.toLowerCase() != tag) {
            while (tar = tar.parentNode) {
                //对下拉框的点击会回溯到document，其它最多回溯到document.body即可
                if (tar == parent || tar == document.body || tar == document) {
                    return null;
                } else if (tar.nodeName.toLowerCase() == tag) {
                    break;
                }
            }
        }
        ;
        return tar;
    },
    htmlEncode: function (str) {
        return typeof(str) != "string" ? "" : str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/\'/g, "&apos;").replace(/ /g, "&nbsp;");
    },
    htmlDecode: function (str) {
        return typeof(str) != "string" ? "" : str.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&nbsp;/g, " ").replace(/&#39;/g, "'").replace(/&amp;/g, "&").replace(/&#47;/g, "/");
    },
    time33: function () {
        for (var i = 0, len = str.length, hash = 5381; i < len; ++i) {
            hash += (hash << 5) + str.charAt(i).charCodeAt();
        }
        ;
        return hash & 0x7fffffff;
    },
    loadJS(id, url) {
        var xmlHttp = null;
        if (window.ActiveXObject)//IE
        {
            try {
                //IE6以及以后版本中可以使用
                xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
            }
            catch (e) {
                //IE5.5以及以后版本可以使用
                xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
            }
        }
        else if (window.XMLHttpRequest)//Firefox，Opera 8.0+，Safari，Chrome
        {
            xmlHttp = new XMLHttpRequest();
        }
        //采用同步加载
        xmlHttp.open("GET", url, false);
        //发送同步请求，如果浏览器为Chrome或Opera，必须发布后才能运行，不然会报错
        xmlHttp.send(null);
        //4代表数据发送完毕
        if (xmlHttp.readyState == 4) {
            //0为访问的本地，200到300代表访问服务器成功，304代表没做修改访问的是缓存
            if ((xmlHttp.status >= 200 && xmlHttp.status < 300) || xmlHttp.status == 0 || xmlHttp.status == 304) {
                var myHead = document.getElementsByTagName("HEAD").item(0);
                var myScript = document.createElement("script");
                myScript.language = "javascript";
                myScript.type = "text/javascript";
                myScript.id = id;
                try {
                    //IE8以及以下不支持这种方式，需要通过text属性来设置
                    myScript.appendChild(document.createTextNode(xmlHttp.responseText));
                }
                catch (ex) {
                    myScript.text = xmlHttp.responseText;
                }
                myHead.appendChild(myScript);
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    },
    asyncLoadJS(a, c) {
        var script = document.getElementsByTagName('script');
        for (var i = 0; i < script.length; i++) {
            if (script[i].src == a) {
                script[i].onload = script[i].onreadystatechange = stateChange;
                if (!script[i].callback) {
                    script[i].callback = [];
                }
                script[i].callback.push(c);
                return;
            }
        }
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.src = a;
        document.getElementsByTagName("head")[0].appendChild(b);
        b.onload = b.onreadystatechange = stateChange;
        if (!b.callback) {
            b.callback = [];
        }
        b.callback.push(c);

        function stateChange() {
            if (!this.readyState || this.readyState == "loaded" || this.readyState == "complete") {
                var callbackList = this.callback;
                for (var i = 0; i < callbackList.length; i++) {
                    var _c = callbackList[i];
                    if (typeof _c === "function") {
                        _c();
                    }
                }
            }
        };
    },
    xss: function (str, type) {
        //空过滤
        if (!str) {
            return str === 0 ? "0" : "";
        }

        switch (type) {
            case "none": //过度方案
                return str + "";
            case "html": //过滤html字符串中的XSS
                return str.replace(/[&'"<>\/\\\-\x00-\x09\x0b-\x0c\x1f\x80-\xff]/g, function (r) {
                    return "&#" + r.charCodeAt(0) + ";"
                }).replace(/ /g, " ").replace(/\r\n/g, "<br />").replace(/\n/g, "<br />").replace(/\r/g, "<br />");
            case "htmlEp": //过滤DOM节点属性中的XSS
                return str.replace(/[&'"<>\/\\\-\x00-\x1f\x80-\xff]/g, function (r) {
                    return "&#" + r.charCodeAt(0) + ";"
                });
            case "url": //过滤url
                return escape(str).replace(/\+/g, "%2B");
            case "miniUrl":
                return str.replace(/%/g, "%25");
            case "script":
                return str.replace(/[\\"']/g, function (r) {
                    return "\\" + r;
                }).replace(/%/g, "\\x25").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\x01/g, "\\x01");
            case "reg":
                return str.replace(/[\\\^\$\*\+\?\{\}\.\(\)\[\]]/g, function (a) {
                    return "\\" + a;
                });
            default:
                return escape(str).replace(/[&'"<>\/\\\-\x00-\x09\x0b-\x0c\x1f\x80-\xff]/g, function (r) {
                    return "&#" + r.charCodeAt(0) + ";"
                }).replace(/ /g, " ").replace(/\r\n/g, "<br />").replace(/\n/g, "<br />").replace(/\r/g, "<br />");
        }
    },
    id: function (id) {
        return typeof (id) == "string" ? document.getElementById(id) : id;
    },
    loadCss: function (path, callback) {
        if (!path) {
            return;
        }
        var l;
        if (!window["_loadCss"] || window["_loadCss"].indexOf(path) < 0) {
            l = document.createElement('link');
            l.setAttribute('type', 'text/css');
            l.setAttribute('rel', 'stylesheet');
            l.setAttribute('href', path);
            l.setAttribute("id", "loadCss" + Math.random());
            document.getElementsByTagName("head")[0].appendChild(l);
            window["_loadCss"] ? (window["_loadCss"] += "|" + path) : (window["_loadCss"] = "|" + path);
        }

        l && (typeof callback == "function") && (l.onload = callback);

        return true;
    },
    isBrowser: function (str) {
        str = str.toLowerCase();
        var b = navigator.userAgent.toLowerCase();
        var arrB = [];
        arrB['firefox'] = b.indexOf("firefox") != -1;
        arrB['opera'] = b.indexOf("opera") != -1;
        arrB['safari'] = b.indexOf("safari") != -1;
        arrB['chrome'] = b.indexOf("chrome") != -1;
        arrB['gecko'] = !arrB['opera'] && !arrB['safari'] && b.indexOf("gecko") > -1;
        arrB['ie'] = !arrB['opera'] && b.indexOf("msie") != -1;
        arrB['ie6'] = !arrB['opera'] && b.indexOf("msie 6") != -1;
        arrB['ie7'] = !arrB['opera'] && b.indexOf("msie 7") != -1;
        arrB['ie8'] = !arrB['opera'] && b.indexOf("msie 8") != -1;
        arrB['ie9'] = !arrB['opera'] && b.indexOf("msie 9") != -1;
        arrB['ie10'] = !arrB['opera'] && b.indexOf("msie 10") != -1;
        return arrB[str];
    },
    /**
     *将数字按每三位分割加
     * @param num
     * @returns {string}
     */
    splitNumber: function (num) {
        if (typeof num != 'undefined') {
            return parseFloat(num).toLocaleString();
        }
    },
    namespace: function (name) {
        //使用eval是为了解决ie下global和window不一致的问题
        for (var arr = name.split(','), r = 0, len = arr.length; r < len; r++) {
            for (var i = 0, k, name = arr[r].split('.'), parent = {}; k = name[i]; i++) {
                i === 0 ? eval('(typeof ' + k + ')==="undefined"?(' + k + '={}):"";parent=' + k) : (parent = parent[k] = parent[k] || {});
            }
        }
    },
    reportPerformance(type) {
        if (window.performance && window.performance.timing) {
            document.addEventListener("readystatechange", function () {
                if (document.readyState == "complete") {
                    setTimeout(function () {
                        var value = [];
                        var timing = window.performance.timing;
                        var begin = timing.navigationStart;
                        value.push(timing.navigationStart);
                        value.push(timing.redirectStart);
                        value.push(timing.redirectEnd);
                        value.push(timing.domainLookupStart);
                        value.push(timing.connectStart);
                        value.push(timing.requestStart);
                        value.push(timing.responseStart);
                        value.push(timing.responseEnd);
                        value.push(timing.loadEventEnd);
                        Utils.reportISD(type, value);
                    }, 200);
                }
            }, false);
        }
    },
    /** * 用于把用utf16编码的字符转换成实体字符，以供后台存储 * @param {string} str 将要转换的字符串，其中含有utf16字符将被自动检出 * @return {string} 转换后的字符串，utf16字符将被转换成&#xxxx;形式的实体字符 */
    utf16toEntities: function (str) {
        var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则   
        str = str.replace(patt, function (char) {
            var H, L, code;
            if (char.length === 2) {
                H = char.charCodeAt(0);
                // 取出高位   
                L = char.charCodeAt(1);
                // 取出低位   
                code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00;
                //转换算法  
                return "&#" + code + ";";
            } else {
                return char;
            }
        });
        return str;
    }
}

window.Utils = Utils;
export default Utils;




/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/common/utils.js
 **/